import {
  BarBorder,
  BarLeft,
  BarNumber,
  BarRight,
  BarTextRight,
  BarZone,
  LineBarToolTip,
  LineBarToolTipArrow,
  LineBarToolTipZone,
} from "styles/bar";

import PropTypes from "prop-types";
import React from "react";
import colors from "styles/colors";
import formatNumber from "modules/utils/formatNumber";
import useRect from "modules/utils/useRect";

const OpportunityBar = ({ height = 20, width, value1, value2, text }) => {
  const [rect, ref] = useRect();
  return (
    <BarZone width={width}>
      <BarBorder height={height}>
        <BarLeft value1={value1} value2={value2} bgColor={colors.positiveBar} tooltip={LineBarToolTipZone} ref={ref}>
          <ToolTip value={text} pRect={rect} />
          <BarTextRight space={16} color={colors.white}>
            {text}
          </BarTextRight>
        </BarLeft>
        <BarRight value1={value1} value2={value2} bgColor={colors.positivePlus}>
          <BarTextRight space={16}>
            <BarNumber color={colors.positiveBar} space={5}>
              +{formatNumber(value2)}
            </BarNumber>
          </BarTextRight>
        </BarRight>
      </BarBorder>
    </BarZone>
  );
};

OpportunityBar.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  value1: PropTypes.number.isRequired,
  value2: PropTypes.number.isRequired,
  text: PropTypes.string,
};

export { OpportunityBar };

const ToolTip = ({ value, pRect }) => {
  //eslint-disable-next-line no-unused-vars
  const [rect, ref] = useRect();
  const left = pRect.width / 2 - (ref.current ? ref.current.offsetWidth / 2 : 0);
  const top = -(pRect.height + 15);
  return (
    <LineBarToolTipZone top={top} left={left} ref={ref}>
      <LineBarToolTip
        fontSize="10px"
        bold={false}
        color={colors.tooltip2Text}
        bgColor={colors.tooltip2}
        radius={ref.current ? ref.current.offsetHeight / 2 + "px" : null}
      >
        {value}
      </LineBarToolTip>
      <LineBarToolTipArrow bgColor={colors.tooltip2} />
    </LineBarToolTipZone>
  );
};
